import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $variant?: 'light' | 'primary' }>`
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    display: flex;

    border-radius: 50%;
    border: 1px solid white;
    background: white;

    svg,
    img {
        width: 100%;
        display: flex;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 20px;
        height: 20px;
    }

    ${({ $variant }) =>
        $variant === 'light' &&
        css`
            width: 21px;
            height: 21px;
            border-radius: 50%;
            background-color: ${({ theme }) => theme.shades.white[10]};

            svg,
            img {
                width: unset;
            }

            @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
                width: 23px;
                height: 23px;
            }
        `}
`;
